import React, { useState } from 'react';
import { Platform, Text, TouchableOpacity, View } from 'react-native';
import DateTimePicker from '@react-native-community/datetimepicker';

export default function DateInput({ value, onChangeText, className = '', placeholder = 'YYYY-MM-DD' }) {
  const [showPicker, setShowPicker] = useState(false);

  if (Platform.OS === 'web') {
    return React.createElement('input', {
      type: 'date',
      value: value || '',
      onChange: (event) => onChangeText(event.target.value),
      placeholder,
      style: {
        width: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#e2e8f0',
        backgroundColor: '#f8fafc',
        color: '#020617',
        borderRadius: 16,
        padding: 12,
        fontSize: 16,
        lineHeight: '24px',
        boxSizing: 'border-box',
        outline: 'none',
      },
    });
  }

  const selectedDate = value ? new Date(`${value}T00:00:00`) : new Date();

  return (
    <View>
      <TouchableOpacity
        className={className || 'rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3'}
        onPress={() => setShowPicker(true)}
      >
        <Text className={value ? 'text-slate-950' : 'text-slate-400'}>{value || placeholder}</Text>
      </TouchableOpacity>
      {showPicker ? (
        <DateTimePicker
          value={Number.isNaN(selectedDate.getTime()) ? new Date() : selectedDate}
          mode="date"
          display={Platform.OS === 'ios' ? 'inline' : 'default'}
          onChange={(event, date) => {
            if (Platform.OS !== 'ios') setShowPicker(false);
            if (event.type === 'dismissed') return;
            if (date) onChangeText(date.toISOString().slice(0, 10));
          }}
        />
      ) : null}
      {Platform.OS === 'ios' && showPicker ? (
        <TouchableOpacity className="mt-2 rounded-xl bg-slate-900 px-4 py-2" onPress={() => setShowPicker(false)}>
          <Text className="text-center font-bold text-white">Done</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}
